module.exports = __webpack_public_path__ + "media/reju3.16b2048b.mp4";